/* eslint-disable import/no-anonymous-default-export */
import { Table } from "antd";
import moment from "moment";
import DataTable from "../common/components/DataTable";
import MainLayout from "../common/components/MainLayout";
import useEventosApi, { Evento } from "./useEventosApi";

export default () => {
  const api = useEventosApi();

  // const generateFilters = (filters:Record<string, FilterValue | null>) => {
  //     console.log(filters)
  //     return [
  //         filters?.Nombre != null ?  `contains(Nombre,'${filters!.Nombre![0]}')` : "",

  //     ];
  // }

  return (
    <MainLayout >
      <DataTable<Evento, Evento>
        list={(query) => api.list({...query,...{ $expand: ["Usuario"] }})}
        delete={api.delete}
        deleteMultipleAction
        defaultSortOrder={"CreatedAt desc"}
        title={"Eventos"}
        generateFilters={() => []}
        defaultPageSize={5}
      >

        <Table.Column<Evento>
          title="Fecha"
          dataIndex={"CreatedAt"}
          sorter
          defaultSortOrder={'descend'}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(value) => moment(value).format("DD/MM/YYYY HH:mm:ss")}
          width={"20%"}
        />

        <Table.Column<Evento>
          title="Nombre"
          dataIndex={"Nombre"}
          sortDirections={["ascend", "descend", "ascend"]}
          width={"40%"}
        />

        <Table.Column<Evento>
          title="Usuario"
          dataIndex={"Usuario.NombreUsuario"}
          sortDirections={["ascend", "descend", "ascend"]}
          render={(value, record) => record.Usuario.UserName}
          width={"40%"}
        />


      </DataTable>
    </MainLayout>
  );

};